/* mo-adj-stage.js: "Every position, to scale." Mattress Overstock adjustable bases page, 2026-10-14.
   A side view of an 80 in. base with a mattress on it, in inches (1 SVG unit = 1 in.). The head and foot
   sections hinge on a spring-damper toward each model's published maximum angle; the lift motors are drawn as
   push rods solved from the panel angle (the idea of 21st.dev Pumpjack 35488: the linkage follows the angle, it
   is not tweened). Wall-hugging models slide the deck back as the head rises, so the pillow stays beside the
   nightstand; other models drift away from it. Massage models ripple along their zones. A compare ghost draws a
   second model at its maximum. Spring numbers after 21st.dev Spring Element 2923 and Industrial Switch 24092.
   No library. Plain SVG so the colors come from CSS tokens (dark mode works) and the server still is the same
   drawing. Exposes window.MOAdjStage. */
(function () {
  'use strict';
  if (window.MOAdjStage) return;

  var NS = 'http://www.w3.org/2000/svg';
  var D2R = Math.PI / 180;
  // geometry, inches. Floor at y = 0 (up is +y); SVG y = FLOOR - y.
  var G = { FLOOR: 60, X0: 4, DECK: 14, LH: 31, LS: 11, LT: 16, LC: 22, T: 11, FRAME_T: 13, FRAME_B: 10.8 };
  // when a maker publishes no angle the drawing still moves, but no degrees are shown
  var FALLBACK = { head: 50, foot: 30, zgh: 28, zgf: 30, snore: 10, snoreresp: 12, tv: 40, lounge: 30 };

  function sx(x) { return +x.toFixed(2); }
  function sy(y) { return +(G.FLOOR - y).toFixed(2); }
  function el(tag, attrs, parent) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }

  /* --- pose: deck polyline for head angle h, foot angle f (degrees) --- */
  function deck(h, f, hug) {
    var ch = Math.cos(h * D2R), shh = Math.sin(h * D2R);
    var dx = hug ? -G.LH * (1 - ch) : 0;
    var hx = G.X0 + G.LH + dx;
    var H = [hx, G.DECK];
    var tip = [hx - G.LH * ch, G.DECK + G.LH * shh];
    var S = [hx + G.LS, G.DECK];
    var cf = Math.cos(f * D2R), sf = Math.sin(f * D2R);
    var K = [S[0] + G.LT * cf, S[1] + G.LT * sf];
    var phi = -f * 0.55 * D2R;
    var F = [K[0] + G.LC * Math.cos(phi), K[1] + G.LC * Math.sin(phi)];
    return { pts: [tip, H, S, K, F], dx: dx, H: H, S: S };
  }

  // the mattress top is the deck offset by its thickness: mitred where the deck folds in (the hip), rounded where
  // it folds out (the knee), then resampled and relaxed a little, because foam bends rather than creases
  function mattress(dk, t, ripple) {
    var P = dk.pts, seg = [], i, j;
    for (i = 0; i < 4; i++) {
      var a = P[i], b = P[i + 1], L = Math.hypot(b[0] - a[0], b[1] - a[1]);
      var d = [(b[0] - a[0]) / L, (b[1] - a[1]) / L];
      seg.push({ a: a, d: d, n: [-d[1], d[0]], L: L });
    }
    var T = G.T, raw = [[P[0][0] + seg[0].n[0] * T, P[0][1] + seg[0].n[1] * T]];
    for (j = 1; j < 4; j++) {
      var s0 = seg[j - 1], s1 = seg[j], cr = s0.d[0] * s1.d[1] - s0.d[1] * s1.d[0];
      if (cr > 1e-4) {
        var A = [s0.a[0] + s0.n[0] * T, s0.a[1] + s0.n[1] * T], B = [s1.a[0] + s1.n[0] * T, s1.a[1] + s1.n[1] * T];
        var u = ((B[0] - A[0]) * s1.d[1] - (B[1] - A[1]) * s1.d[0]) / cr;
        raw.push([A[0] + s0.d[0] * u, A[1] + s0.d[1] * u]);
      } else if (cr < -1e-4) {
        var g0 = Math.atan2(s0.n[1], s0.n[0]), g1 = Math.atan2(s1.n[1], s1.n[0]);
        while (g1 > g0) g1 -= 2 * Math.PI;
        for (var q = 0; q <= 6; q++) { var g = g0 + (g1 - g0) * q / 6; raw.push([P[j][0] + Math.cos(g) * T, P[j][1] + Math.sin(g) * T]); }
      } else raw.push([P[j][0] + s0.n[0] * T, P[j][1] + s0.n[1] * T]);
    }
    raw.push([P[4][0] + seg[3].n[0] * T, P[4][1] + seg[3].n[1] * T]);
    // resample by arc length
    var cum = [0];
    for (i = 1; i < raw.length; i++) cum.push(cum[i - 1] + Math.hypot(raw[i][0] - raw[i - 1][0], raw[i][1] - raw[i - 1][1]));
    var total = cum[cum.length - 1], N = 80, top = [], k = 0;
    for (i = 0; i <= N; i++) {
      var sd = total * i / N;
      while (k < raw.length - 2 && cum[k + 1] < sd) k++;
      var w = (sd - cum[k]) / ((cum[k + 1] - cum[k]) || 1);
      top.push([raw[k][0] + (raw[k + 1][0] - raw[k][0]) * w, raw[k][1] + (raw[k + 1][1] - raw[k][1]) * w]);
    }
    for (var pass = 0; pass < 3; pass++) {
      var nt = top.map(function (p) { return p.slice(); });
      for (i = 1; i < N; i++) for (var c = 0; c < 2; c++) nt[i][c] = 0.25 * top[i - 1][c] + 0.5 * top[i][c] + 0.25 * top[i + 1][c];
      top = nt;
    }
    var nrm = [];
    for (i = 0; i <= N; i++) {
      var p0 = top[Math.max(0, i - 1)], p1 = top[Math.min(N, i + 1)], dl = Math.hypot(p1[0] - p0[0], p1[1] - p0[1]) || 1;
      nrm.push([-(p1[1] - p0[1]) / dl, (p1[0] - p0[0]) / dl]);
    }
    if (ripple && ripple.amp > 0) {
      for (i = 1; i < N; i++) {
        var s2 = total * i / N, m = 0;
        for (var z = 0; z < ripple.zones.length; z++) {
          var zn = ripple.zones[z], qq = 1 - Math.abs(s2 / total - zn[0]) / zn[1];
          if (qq > 0) m = Math.max(m, Math.sin(qq * Math.PI / 2));
        }
        if (!m) continue;
        var off = ripple.amp * m * Math.sin(s2 * 0.42 - t * ripple.speed);
        top[i] = [top[i][0] + nrm[i][0] * off, top[i][1] + nrm[i][1] * off];
      }
    }
    return { deck: P, top: top, nrm: nrm, total: total, n0: seg[0].n, n3: seg[3].n };
  }

  function linePath(pts) {
    var s = '';
    for (var i = 0; i < pts.length; i++) s += (i ? 'L' : 'M') + sx(pts[i][0]) + ' ' + sy(pts[i][1]);
    return s;
  }

  function mattressPath(m) {
    var b = m.deck, t = m.top, N = t.length - 1, r = 2.4;
    var s = 'M' + sx(b[4][0]) + ' ' + sy(b[4][1]);
    for (var i = 3; i >= 0; i--) s += 'L' + sx(b[i][0]) + ' ' + sy(b[i][1]);
    // rounded ends: bulge outward along the deck direction
    var h0 = [-m.n0[1], m.n0[0]], c0 = [b[0][0] + (t[0][0] - b[0][0]) / 2 + h0[0] * r, b[0][1] + (t[0][1] - b[0][1]) / 2 + h0[1] * r];
    s += 'Q' + sx(c0[0]) + ' ' + sy(c0[1]) + ' ' + sx(t[0][0]) + ' ' + sy(t[0][1]);
    for (i = 1; i <= N; i++) s += 'L' + sx(t[i][0]) + ' ' + sy(t[i][1]);
    var h3 = [m.n3[1], -m.n3[0]], c3 = [b[4][0] + (t[N][0] - b[4][0]) / 2 + h3[0] * r, b[4][1] + (t[N][1] - b[4][1]) / 2 + h3[1] * r];
    s += 'Q' + sx(c3[0]) + ' ' + sy(c3[1]) + ' ' + sx(b[4][0]) + ' ' + sy(b[4][1]) + 'Z';
    return s;
  }

  function offsetLine(m, d, from, to) {
    var pts = [], N = m.top.length - 1;
    for (var i = Math.round(from * N); i <= Math.round(to * N); i++) pts.push([m.top[i][0] - m.nrm[i][0] * d, m.top[i][1] - m.nrm[i][1] * d]);
    return linePath(pts);
  }

  function bandPath(m, d) {
    var N = m.top.length - 1, a = Math.round(0.02 * N), z = Math.round(0.98 * N), i, p = '';
    for (i = a; i <= z; i++) p += (i === a ? 'M' : 'L') + sx(m.top[i][0]) + ' ' + sy(m.top[i][1]);
    for (i = z; i >= a; i--) p += 'L' + sx(m.top[i][0] - m.nrm[i][0] * d) + ' ' + sy(m.top[i][1] - m.nrm[i][1] * d);
    return p + 'Z';
  }

  function pillowPath(m) {
    var N = m.top.length - 1, a = Math.max(1, Math.round(N * 1.5 / m.total)), z = Math.round(N * 17 / m.total), i;
    var path = '', up = [];
    for (i = a; i <= z; i++) path += (i === a ? 'M' : 'L') + sx(m.top[i][0]) + ' ' + sy(m.top[i][1]);
    for (i = z; i >= a; i--) {
      var u = (i - a) / (z - a), lift = 4.2 * Math.pow(Math.sin(Math.PI * u), 0.5);
      path += 'L' + sx(m.top[i][0] + m.nrm[i][0] * lift) + ' ' + sy(m.top[i][1] + m.nrm[i][1] * lift);
    }
    return path + 'Z';
  }

  function rot(p, c, deg) {
    var r = deg * D2R, x = p[0] - c[0], y = p[1] - c[1];
    return [c[0] + x * Math.cos(r) - y * Math.sin(r), c[1] + x * Math.sin(r) + y * Math.cos(r)];
  }

  function arcPath(c, r, a0, a1) {
    var p0 = [c[0] + r * Math.cos(a0 * D2R), c[1] + r * Math.sin(a0 * D2R)];
    var p1 = [c[0] + r * Math.cos(a1 * D2R), c[1] + r * Math.sin(a1 * D2R)];
    var large = Math.abs(a1 - a0) > 180 ? 1 : 0, sweep = a1 > a0 ? 0 : 1;
    return 'M' + sx(p0[0]) + ' ' + sy(p0[1]) + 'A' + r + ' ' + r + ' 0 ' + large + ' ' + sweep + ' ' + sx(p1[0]) + ' ' + sy(p1[1]);
  }

  /* --- the scene --- */
  function build(svg) {
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '-6 -4 108 68');
    var defs = el('defs', {}, svg);
    var gid = 'mo-adj-glow-' + Math.random().toString(36).slice(2, 7);
    var rg = el('radialGradient', { id: gid, cx: '50%', cy: '50%', r: '50%' }, defs);
    el('stop', { offset: '0', 'class': 'adjs-glow0' }, rg);
    el('stop', { offset: '1', 'class': 'adjs-glow1' }, rg);
    var R = {};
    R.room = el('g', { 'class': 'adjs-room' }, svg);
    el('path', { 'class': 'adjs-wall', d: 'M0 ' + sy(64) + 'V' + sy(0) }, R.room);
    for (var i = 0; i < 13; i++) el('path', { 'class': 'adjs-hatch', d: 'M0 ' + sy(4 + i * 5) + 'l-3 3' }, R.room);
    var ns = el('g', { 'class': 'adjs-stand' }, R.room);
    el('rect', { x: 0.6, y: sy(25), width: 19, height: 25, rx: 1 }, ns);
    el('path', { 'class': 'adjs-stand__line', d: 'M0.6 ' + sy(17) + 'H19.6M0.6 ' + sy(9) + 'H19.6' }, ns);
    el('path', { 'class': 'adjs-stand__lamp', d: 'M5.5 ' + sy(25) + 'h5 l-1 -1.6 h-3 z M8 ' + sy(26.6) + 'V' + sy(34) + 'M3.6 ' + sy(34) + 'h8.8 l-1.8 -6 h-5.2 z' }, ns);
    el('rect', { 'class': 'adjs-stand__cup', x: 14, y: sy(29.5), width: 3, height: 4.5, rx: 0.6 }, ns);
    el('ellipse', { 'class': 'adjs-shadow', cx: 44, cy: sy(0.2), rx: 38, ry: 1.3 }, svg);
    R.glow = el('ellipse', { 'class': 'adjs-glow', cx: 44, cy: sy(0.4), rx: 40, ry: 3.4, fill: 'url(#' + gid + ')' }, svg);
    el('path', { 'class': 'adjs-floor', d: 'M-6 ' + sy(0) + 'H102' }, svg);
    var fr = el('g', { 'class': 'adjs-frame' }, svg);
    el('rect', { x: G.X0 + 2, y: sy(G.FRAME_T), width: 76, height: G.FRAME_T - G.FRAME_B, rx: 0.8 }, fr);
    [G.X0 + 5, G.X0 + 40, G.X0 + 75].forEach(function (x) { el('rect', { 'class': 'adjs-leg', x: x - 1.1, y: sy(G.FRAME_B), width: 2.2, height: G.FRAME_B, rx: 0.5 }, fr); });
    R.rodH = el('g', { 'class': 'adjs-rod' }, svg);
    R.rodHb = el('path', { 'class': 'adjs-rod__body' }, R.rodH);
    R.rodHr = el('path', { 'class': 'adjs-rod__shaft' }, R.rodH);
    R.rodF = el('g', { 'class': 'adjs-rod' }, svg);
    R.rodFb = el('path', { 'class': 'adjs-rod__body' }, R.rodF);
    R.rodFr = el('path', { 'class': 'adjs-rod__shaft' }, R.rodF);
    R.deck = el('path', { 'class': 'adjs-deck' }, svg);
    R.joints = el('g', { 'class': 'adjs-joints' }, svg);
    R.jH = el('circle', { r: 0.9 }, R.joints);
    R.jS = el('circle', { r: 0.9 }, R.joints);
    R.mat = el('path', { 'class': 'adjs-mat' }, svg);
    R.band = el('path', { 'class': 'adjs-band' }, svg);
    R.quilt = el('path', { 'class': 'adjs-quilt' }, svg);
    R.pillow = el('path', { 'class': 'adjs-pillow' }, svg);
    R.ghost = el('g', { 'class': 'adjs-ghost' }, svg);
    R.ghostMat = el('path', {}, R.ghost);
    R.ghostLab = el('text', { 'class': 'adjs-ghost__lab' }, R.ghost);
    R.snore = el('g', { 'class': 'adjs-snore' }, svg);
    for (var w = 0; w < 3; w++) el('path', { 'class': 'adjs-snore__w', style: 'animation-delay:' + (w * 0.22) + 's' }, R.snore);
    R.reach = el('g', { 'class': 'adjs-reach' }, svg);
    R.reachLine = el('path', {}, R.reach);
    R.arcs = el('g', { 'class': 'adjs-arcs' }, svg);
    R.arcH = el('path', { 'class': 'adjs-arc' }, R.arcs);
    R.arcF = el('path', { 'class': 'adjs-arc' }, R.arcs);
    R.labH = el('text', { 'class': 'adjs-deg', 'text-anchor': 'end' }, R.arcs);
    R.labF = el('text', { 'class': 'adjs-deg' }, R.arcs);
    return R;
  }

  function draw(R, st) {
    var dk = deck(st.h, st.f, st.hug);
    var m = mattress(dk, st.t, st.ripple);
    R.deck.setAttribute('d', linePath(dk.pts));
    R.jH.setAttribute('cx', sx(dk.H[0])); R.jH.setAttribute('cy', sy(dk.H[1]));
    R.jS.setAttribute('cx', sx(dk.S[0])); R.jS.setAttribute('cy', sy(dk.S[1]));
    R.mat.setAttribute('d', mattressPath(m));
    R.quilt.setAttribute('d', offsetLine(m, 2.6, 0.02, 0.98));
    R.band.setAttribute('d', bandPath(m, 2.6));
    // sound arcs above the pillow while Snore Response is shown
    var pt = m.top[Math.round((m.top.length - 1) * 6 / m.total)], pn = m.nrm[Math.round((m.top.length - 1) * 6 / m.total)];
    var sc = [pt[0] + pn[0] * 7, pt[1] + pn[1] * 7];
    for (var w = 0; w < 3; w++) {
      var r = 1.6 + w * 1.5;
      R.snore.childNodes[w].setAttribute('d', 'M' + sx(sc[0] - r * 0.7) + ' ' + sy(sc[1] + r * 0.7) + 'A' + r + ' ' + r + ' 0 0 1 ' + sx(sc[0] + r * 0.7) + ' ' + sy(sc[1] + r * 0.7));
    }
    R.snore.setAttribute('data-on', st.snore ? '1' : '0');
    R.pillow.setAttribute('d', pillowPath(m));
    // lift motors: a body fixed to the frame, a rod to a lever under each hinge
    var lh = rot([dk.H[0], dk.H[1] - 4.6], dk.H, -st.h);
    var anchorH = [dk.H[0] + 15, 9.4];
    rodDraw(R.rodHb, R.rodHr, anchorH, lh);
    var lf = rot([dk.S[0], dk.S[1] - 5.6], dk.S, st.f);
    var anchorF = [dk.S[0] - 14, 8.6];
    rodDraw(R.rodFb, R.rodFr, anchorF, lf);
    // reach: pillow centre to the nightstand front edge, at pillow height
    var pc = m.top[Math.round((m.top.length - 1) * 9 / m.total)];
    var near = pc[0] <= 21;
    R.reach.setAttribute('data-near', near ? '1' : '0');
    var ry = sy(26.6), rx = sx(Math.max(19.6, pc[0]));
    R.reachLine.setAttribute('d', 'M19.6 ' + ry + 'H' + rx + 'M19.6 ' + (ry - 1.2) + 'v2.4M' + rx + ' ' + (ry - 1.2) + 'v2.4');
    // angle arcs (labels only when the angle is a published number)
    var aH = Math.max(0.01, st.h), aF = Math.max(0.01, st.f);
    R.arcH.setAttribute('d', arcPath(dk.H, 8, 180, 180 - aH));
    R.arcF.setAttribute('d', arcPath(dk.S, 7, 0, aF));
    var hm = rot([dk.H[0] - 12.5, dk.H[1]], dk.H, -aH / 2);
    var fm = rot([dk.S[0] + 10.5, dk.S[1]], dk.S, aF / 2);
    R.labH.setAttribute('x', sx(hm[0] + 1.2)); R.labH.setAttribute('y', sy(hm[1] - 1.2));
    R.labF.setAttribute('x', sx(fm[0] + 1)); R.labF.setAttribute('y', sy(fm[1] - 1.4));
    R.labH.textContent = st.labH || '';
    R.labF.textContent = st.labF || '';
    R.arcs.setAttribute('data-h', st.h > 2 ? '1' : '0');
    R.arcs.setAttribute('data-f', st.f > 2 ? '1' : '0');
    R.labH.style.opacity = st.h > 8 && st.labH ? 1 : 0;
    R.labF.style.opacity = st.f > 12 && st.labF ? 1 : 0;
    R.glow.style.opacity = st.light ? 1 : 0;
    if (st.ghost) {
      var gd = deck(st.ghost.h, st.ghost.f, st.ghost.hug), gm = mattress(gd, 0, null);
      R.ghostMat.setAttribute('d', mattressPath(gm));
      var gt = gm.top[0];
      R.ghostLab.setAttribute('x', sx(Math.max(gt[0], 22) + 1)); R.ghostLab.setAttribute('y', sy(gt[1] + 2.2));
      R.ghostLab.textContent = st.ghost.label;
      R.ghost.style.opacity = 1;
    } else R.ghost.style.opacity = 0;
    return { near: near };
  }

  function rodDraw(body, shaft, a, b) {
    var L = Math.hypot(b[0] - a[0], b[1] - a[1]), d = [(b[0] - a[0]) / L, (b[1] - a[1]) / L];
    var bl = Math.min(9, L * 0.62), m = [a[0] + d[0] * bl, a[1] + d[1] * bl];
    body.setAttribute('d', 'M' + sx(a[0]) + ' ' + sy(a[1]) + 'L' + sx(m[0]) + ' ' + sy(m[1]));
    shaft.setAttribute('d', 'M' + sx(m[0]) + ' ' + sy(m[1]) + 'L' + sx(b[0]) + ' ' + sy(b[1]));
  }

  /* --- motion: two joints on spring-dampers with a motor speed limit --- */
  function Stage(svg, opts) {
    opts = opts || {};
    this.svg = svg;
    this.R = build(svg);
    this.reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.speed = opts.speed || 34; // degrees per second at full travel; the demo is sped up and says so
    this.k = 60; this.c = 13.5; // stiffness and damping per unit inertia (after Spring Element 2923)
    this.s = { h: opts.h || 0, f: opts.f || 0, vh: 0, vf: 0, th: opts.h || 0, tf: opts.f || 0, hug: !!opts.hug,
      t: 0, ripple: null, light: false, ghost: null, labH: '', labF: '' };
    this.onFrame = opts.onFrame || null;
    this.onSettle = opts.onSettle || null;
    this.raf = 0; this.last = 0; this.visible = true; this.massage = null;
    var self = this;
    this.tick = function (now) { self._tick(now); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        self.visible = es[0].isIntersecting;
        if (self.visible) self.wake();
      }, { rootMargin: '80px' }).observe(svg);
    }
    this.render();
  }
  Stage.prototype.render = function () {
    var r = draw(this.R, this.s);
    if (this.onFrame) this.onFrame(this.s, r);
  };
  Stage.prototype.to = function (h, f, opts) {
    opts = opts || {};
    this.s.th = h; this.s.tf = f;
    if (opts.hug !== undefined) this.s.hug = !!opts.hug;
    if (this.reduced || opts.jump) {
      this.s.h = h; this.s.f = f; this.s.vh = this.s.vf = 0;
      this.render();
      if (this.onSettle) this.onSettle(this.s);
      return;
    }
    this.wake();
  };
  Stage.prototype.set = function (patch) {
    for (var k in patch) this.s[k] = patch[k];
    this.render();
    this.wake();
  };
  Stage.prototype.setMassage = function (zones) {
    // zones: [[centre 0..1 along the bed, half width 0..1], ...] or null
    this.massage = zones && zones.length ? zones : null;
    this.s.ripple = this.massage && !this.reduced ? { zones: this.massage, amp: 0.42, speed: 3.4 } : null;
    this.render();
    this.wake();
  };
  Stage.prototype.wake = function () {
    if (!this.raf && this.visible && !document.hidden) { this.last = 0; this.raf = requestAnimationFrame(this.tick); }
  };
  Stage.prototype._tick = function (now) {
    this.raf = 0;
    var s = this.s, dt = this.last ? Math.min(0.034, (now - this.last) / 1000) : 1 / 60;
    this.last = now;
    s.t += dt;
    var moving = false, sub = 4, h = dt / sub;
    for (var i = 0; i < sub; i++) {
      var ah = this.k * (s.th - s.h) - this.c * s.vh, af = this.k * (s.tf - s.f) - this.c * s.vf;
      s.vh += ah * h; s.vf += af * h;
      var cap = this.speed;
      s.vh = Math.max(-cap, Math.min(cap, s.vh)); s.vf = Math.max(-cap, Math.min(cap, s.vf));
      s.h += s.vh * h; s.f += s.vf * h;
    }
    if (Math.abs(s.th - s.h) > 0.02 || Math.abs(s.vh) > 0.05 || Math.abs(s.tf - s.f) > 0.02 || Math.abs(s.vf) > 0.05) moving = true;
    else if (s.h !== s.th || s.f !== s.tf) { s.h = s.th; s.f = s.tf; s.vh = s.vf = 0; if (this.onSettle) this.onSettle(s); }
    this.render();
    if ((moving || s.ripple) && this.visible && !document.hidden) this.raf = requestAnimationFrame(this.tick);
  };

  /* --- positions for one model: published angles where the maker gives them, a drawn guess without degrees
     otherwise. m: {head, foot, zgh, zgf, presets: 'flat,zerog,...', pangles: 'snore:12,tv:45/0', hug} --- */
  var NAMES = { flat: 'Flat', zerog: 'Zero-G', snore: 'Anti-snore', snoreresp: 'Snore Response', tv: 'TV', lounge: 'Lounge', max: 'Highest' };
  function num(v) { return typeof v === 'number' && isFinite(v) ? v : null; }
  function positions(m) {
    var list = String(m.presets || '').toLowerCase().split(/[\s,]+/).filter(Boolean), pa = {}, out = [];
    String(m.pangles || '').split(',').forEach(function (x) {
      var kv = x.split(':'); if (kv.length < 2) return;
      var hf = kv[1].split('/'); pa[kv[0].trim().toLowerCase()] = { h: num(parseFloat(hf[0])), f: hf.length > 1 ? num(parseFloat(hf[1])) : 0 };
    });
    var H = num(m.head), F = num(m.foot);
    function add(id, h, f, pubH, pubF) { out.push({ id: id, name: NAMES[id], h: h, f: f, pubH: pubH, pubF: pubF }); }
    add('flat', 0, 0, true, true);
    if (list.indexOf('zerog') > -1) {
      var zh = num(m.zgh), zf = num(m.zgf);
      add('zerog', zh !== null ? zh : FALLBACK.zgh, zf !== null ? zf : FALLBACK.zgf, zh !== null, zf !== null);
    }
    ['snore', 'snoreresp', 'tv', 'lounge'].forEach(function (id) {
      if (list.indexOf(id) < 0) return;
      var p = pa[id];
      if (p && p.h !== null) add(id, p.h, p.f || 0, true, true);
      else add(id, FALLBACK[id], id === 'lounge' ? 12 : 0, false, id !== 'lounge');
    });
    add('max', H !== null ? H : FALLBACK.head, F !== null ? F : FALLBACK.foot, H !== null, F !== null);
    return out;
  }
  // the drawing opens raised, never on a "press me" flat bed: at the published maximums when the maker gives
  // them, else on Zero-G, else head up
  function opening(m) {
    var ps = positions(m), z = null, mx = null;
    ps.forEach(function (p) { if (p.id === 'zerog') z = p; if (p.id === 'max') mx = p; });
    if (mx.pubH && mx.pubF) return mx;
    if (z) return z;
    return { id: 'max', name: NAMES.max, h: mx.h, f: 0, pubH: mx.pubH, pubF: true };
  }

  window.MOAdjStage = {
    G: G,
    FALLBACK: FALLBACK,
    positions: positions,
    opening: opening,
    create: function (svg, opts) { return new Stage(svg, opts); },
    // the server still: the same drawing as a string, for build time (node) or no-JS
    still: function (h, f, hug) {
      return { deck: deck(h, f, hug), mattress: mattress(deck(h, f, hug), 0, null) };
    }
  };
})();
